import { createContext } from 'react'

// Lets the Enrollments & Billing page register its list-refresh handler so the Create Enrollment
// action, which lives in the layout header (PageHeader), can refresh the table after a successful
// create even though it sits outside the routed page component.
const EnrollmentsBillingContext = createContext({ registerRefresh: () => {} })

export default EnrollmentsBillingContext
